function MenuLogo() {
    return (
        <a className="brand-link text-center" href="/">
            <img src="https://1cer.ru/assets/images/logo.svg" alt="1CER Logo" className="brand-logo" style={{ opacity: 0.8 }} />
            <img src="https://1cer.ru/assets/images/logo-sm.svg" alt="1CER Logo" className="brand-image d-none" style={{ opacity: 0.8 }} />
            <span className="brand-text font-weight-light d-none">1CER</span>
        </a>
    );
}

export default MenuLogo;
